import { registerCollisionAnimation } from './CollisionAnimationRegistry';
import { seedRandom } from '../../../break/BreakUtils';

registerCollisionAnimation('SPARKS', (ctx, e, config, progress, elapsed, globalHue, determineColor) => {
  const particles = config.collisionEffectParticleCount || 20;
  for (let i = 0; i < particles; i++) {
    const rnd = seedRandom(e.id, i);
    const angle = rnd * Math.PI * 2;
    const speed = 15 * rnd;
    const dist = speed * elapsed * 0.1;
    const x = e.pos.x + Math.cos(angle) * dist;
    const y = e.pos.y + Math.sin(angle) * dist;

    ctx.strokeStyle = determineColor(i, particles);
    ctx.globalAlpha = Math.max(0, 1 - progress * 1.5);
    ctx.lineWidth = 1;
    ctx.beginPath(); ctx.moveTo(x, y);
    ctx.lineTo(x - Math.cos(angle) * 15, y - Math.sin(angle) * 15);
    ctx.stroke();
  }
});
